import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetEffectiveCustomerLimitsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetEffectiveCustomerLimitsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getEffectiveCustomerLimits = (request: GetEffectiveCustomerLimitsRequest, options?: CashRequestOptions) =>
  post<GetEffectiveCustomerLimitsRequest, GetEffectiveCustomerLimitsResponse>(
    '/2.0/cash/get-effective-customer-limits',
    request,
    { ...options, rejectOnError: true }
  )
